module.exports = __webpack_public_path__ + "img/icon6.4c3df1d5.png";